import { render } from "./salestax-report.vue?vue&type=template&id=520ea986"
import script from "./salestax-report.vue?vue&type=script&lang=js"
export * from "./salestax-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__